import { getenv } from '~/settings'

export const CANCELED_STATUS = 'canceled'
export const IN_PRODUCTION_STATUS = 'in_production'
export const ORDER_COMPLETE_STATUS = 'order_complete'
export const PARTIAL_SHIPPING_STATUS = 'partially_shipped'
export const PENDING_PRODUCTION_STATUS = 'pending_production'
export const PROCESS_STEP_STATUS = 'process'
export const READY_SHIPPING_STATUS = 'ready_to_ship'
export const SHIPPED_STATUS = 'shipped'

export const DELIVERED_DISPLAY = 'Delivered'
export const ESTIMATED_DELIVERY_DATE_DISPLAY = 'Estimated delivery date'
export const ESTIMATED_SHIP_DATE_DISPLAY = 'Estimated ship date'
export const IN_PRODUCTION_DISPLAY = 'In production'
export const ORDER_RECEIVED_STATE_DISPLAY = 'Order received'
export const PARTIAL_SHIPPING_DISPLAY = 'Partially shipped'
export const PENDING_PRODUCTION_DISPLAY = 'Production pending'
export const PRODUCTION_COMPLETE_DISPLAY = 'Production complete'
export const SHIPPED_DISPLAY = 'Shipped'

export const SHIPMENTS_TAB = 'shipments'
export const ORDER_STATUS_TAB = 'order-status'
export const MANUFACTURABILITY_FEEDBACK_TAB = 'manufacturability-feedback'
export const CUSTOMS_TAB = 'customs'

export const ORDER_COMPLETE_STATE = 'shipped'

export const PARTIAL_SHIPPING_MULTI_SHIPMENT_TEXT = 'See shipments'
export const PARTIAL_SHIPPING_PART_STATUS = 'See part status'

export const PLACEMENT = 'order-detail-page'
export const NAME = 'all-orders'

export const CHECKOUT_PAGE = 'checkout_page'
export const TRACKING_CODE_PLACEMENT = 'shipment-tracking-code'

export const DELIVERY_STATUSES = {
    UNKNOWN: 'unknown',
    PRE_TRANSIT: 'pre_transit',
    IN_TRANSIT: 'in_transit',
    OUT_FOR_DELIVERY: 'out_for_delivery',
    DELIVERED: 'delivered',
    RETURN_TO_SENDER: 'return_to_sender',
    FAILURE: 'failure',
    CANCELLED: 'cancelled',
    ERROR: 'error',
}

export const SALES_ORDER_DETAILS = 'sales-order-details'
export const SALES_ORDER_CARD = 'sales-order-card'
export const NOT_SHIPPED_KEY = 'not-shipped'
export const DOWNLOAD_ORDER_CONFIRMATION = 'Download order confirmation'
export const ORDER_CONFIRMATION = 'Order confirmation'
export const FEDEX_CARRIER_TYPE = 'fedex'
export const UPS_CARRIER_TYPE = 'ups'
export const DHL_EXPRESS_CARRIER_TYPE = 'DHLExpress'
export const UPS_URL =
    'http://wwwapps.ups.com/WebTracking/track?loc=en_US&track.x=Track&trackNums='
export const FEDEX_URL = 'https://www.fedex.com/fedextrack/?tracknumbers='
export const DHL_EXPRESS_URL =
    'http://www.dhl.com/en/express/tracking.html?AWB='
export const ORDER_CANCELLATION_REFUND_URL = `${
    getenv('REGIONAL_CONFIGS')?.urls
        ?.can_i_cancel_or_make_changes_to_an_existing_order
}`

export const PURCHASE_ORDER = 'po'
export const CREDIT_CARD = 'cc'
export const CARD = 'card'
export const ACH_ACCOUNT = 'ach'

export const HTS_TAB_DETAILS = 'hts-tab-details'
export const ERROR_STATUS = 'Please resolve errors before submitting'

export const SHIPPING_METHOD_DISPLAY_NAMES = {
    pick_up: 'Customer Pick Up',
    courier: 'Courier',
    overnight: 'One day',
    one_day: 'One day',
    ground: 'Standard',
    overseas_1_day: 'International priority',
    overseas_economy: 'International economy',
    standard: 'Standard',
    no_shipping: 'No Shipping',
    freight_forwarder: 'Freight Forwarder',
    customer_freight_forwarder: 'Customer Freight Forwarder',
}

export const PRODUCT_PENDING_STATUS = 'pending'
export const PRODUCT_COMPLETED_STATUS = 'completed'
export const PRODUCT_INPROGRESS_STATUS = 'in_progress'
export const PRODUCT_NA_STATUS = 'na'
export const MOLD_DESIGN_IN_PROGRESS = 'Mold design in progress'
export const MOLD_FABRICATION_IN_PROGRESS = 'Mold fabrication in progress'
export const MOLD_COMPLETE_TRAILING_IN_PROGRESS =
    'Mold complete - Trialing in progress'
export const MOLD_READY_FOR_PRODUCTION = 'Mold ready for production'
export const PART_PRODUCTION_COMPLETE = 'Part production complete'

export const INSPECTION_AND_PROD_STATUS: { [key: string]: string } = {
    [PRODUCT_PENDING_STATUS]: 'Pending',
    [PRODUCT_COMPLETED_STATUS]: 'Complete',
    [PRODUCT_INPROGRESS_STATUS]: 'In progress',
    [PRODUCT_NA_STATUS]: 'N/A',
}

export const DDP_HTS_OVERSEAS_ORDER_LIMIT = 800

export const OVERSEAS_ORDER_STATUSES = Object.freeze({
    OVERSEAS: 'overseas',
    FLEX: 'flex',
    SAVER: 'saver',
})

export const NO_SEARCH_RESULT_DESCRIPTION_TEXT =
    'Try searching for partial part file names, order IDs, and PO#’s to improve your search results'

export const QUOTE_NAME_LENGTH = 20
